<template>
  <svg
    :width="width"
    viewBox="0 0 265 240"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M216.894 119.623C184.276 73.3961 154.396 56.67 123.496 70.5263C92.5956 84.3826 49.2945 160.862 69.9772 201.833C90.6598 242.805 167.494 232.754 198.394 218.897C229.294 205.041 263.188 174.788 216.894 119.623Z"
      :fill="getColor('0.1', primaryColor)"
    />
    <path
      d="M213.941 166.752L201.984 174.9L215.775 181.98L213.941 166.752Z"
      :fill="getColor('0.6', primaryColor)"
    />
    <path
      d="M204.57 142.121L194.531 142.382L199.91 151.691L204.57 142.121Z"
      fill="white"
    />
    <path
      d="M120.265 202.596L110.226 202.857L115.605 212.166L120.265 202.596Z"
      fill="white"
    />
    <path
      d="M98.6383 188.007L84.5653 184.629L88.5784 199.593L98.6383 188.007Z"
      :fill="getColor('0.6', primaryColor)"
    />
    <path
      d="M187.797 239.713L92.7598 166.412L175.375 119.234L187.797 239.713Z"
      :fill="getColor('1', primaryLight)"
      :stroke="getColor('0.8', textColor)"
      stroke-width="3"
    />
    <path
      d="M126.718 129.921C138.59 123.141 150.033 118.326 158.911 116.002C163.361 114.837 167.081 114.321 169.853 114.453C172.709 114.589 174.095 115.379 174.615 116.288C175.136 117.198 175.114 118.792 173.781 121.32C172.488 123.773 170.155 126.714 166.892 129.954C160.382 136.417 150.421 143.824 138.549 150.604C126.677 157.384 115.234 162.2 106.356 164.524C101.906 165.689 98.1852 166.205 95.4138 166.073C92.5574 165.937 91.1719 165.147 90.6514 164.237C90.131 163.327 90.153 161.734 91.4854 159.206C92.7782 156.753 95.1115 153.812 98.3745 150.572C104.885 144.108 114.845 136.701 126.718 129.921Z"
      :fill="getColor('1', primaryColor)"
      :stroke="getColor('0.8', textColor)"
      stroke-width="3"
    />
    <rect
      width="3.83335"
      height="11.5004"
      transform="matrix(0.227532 -0.973395 0.974193 0.227332 30.4269 133.931)"
      :fill="getColor('0.6', primaryColor)"
    />
    <rect
      width="3.83347"
      height="11.5"
      transform="matrix(-0.974193 -0.227332 0.227532 -0.973395 37.0241 139.406)"
      :fill="getColor('0.6', primaryColor)"
    />
    <rect
      width="3.83345"
      height="11.5001"
      transform="matrix(0.283664 -0.958542 0.959375 0.283428 110.33 115.576)"
      fill="white"
    />
    <rect
      width="3.83337"
      height="11.5003"
      transform="matrix(-0.959375 -0.283428 0.283664 -0.958542 116.598 121.422)"
      fill="white"
    />
    <rect
      width="3.83345"
      height="11.5001"
      transform="matrix(0.283664 -0.958542 0.959375 0.283428 183.932 103.356)"
      fill="white"
    />
    <rect
      width="3.83337"
      height="11.5003"
      transform="matrix(-0.959375 -0.283428 0.283664 -0.958542 190.2 109.202)"
      fill="white"
    />
    <rect
      width="3.83345"
      height="11.5001"
      transform="matrix(0.283664 -0.958542 0.959375 0.283428 148.835 53.0288)"
      :fill="getColor('0.6', primaryColor)"
    />
    <rect
      width="3.83337"
      height="11.5003"
      transform="matrix(-0.959375 -0.283428 0.283664 -0.958542 155.103 58.875)"
      :fill="getColor('0.6', primaryColor)"
    />
    <ellipse
      rx="3.83345"
      ry="3.83337"
      transform="matrix(0.283663 -0.958542 0.959375 0.283428 56.8287 147.717)"
      :fill="getColor('0.8', textColor)"
    />
    <ellipse
      rx="3.83345"
      ry="3.83337"
      transform="matrix(0.283663 -0.958542 0.959375 0.283428 90.6471 107.761)"
      :fill="getColor('0.8', textColor)"
    />
    <ellipse
      rx="3.83345"
      ry="3.83337"
      transform="matrix(0.283663 -0.958542 0.959375 0.283428 152.673 94.1191)"
      :fill="getColor('0.8', textColor)"
    />
    <ellipse
      rx="3.83345"
      ry="3.83337"
      transform="matrix(0.283663 -0.958542 0.959375 0.283428 182.686 67.0248)"
      :fill="getColor('0.8', textColor)"
    />
    <ellipse
      rx="3.83345"
      ry="3.83337"
      transform="matrix(0.283663 -0.958542 0.959375 0.283428 115.402 51.1426)"
      :fill="getColor('0.8', textColor)"
    />
    <ellipse
      rx="3.83345"
      ry="3.83337"
      transform="matrix(0.283663 -0.958542 0.959375 0.283428 51.9039 110.301)"
      :fill="getColor('0.8', textColor)"
    />
    <path
      d="M113.33 100.463C109.219 84.6806 109.393 76.9507 111.595 64.0045"
      :stroke="getColor('0.8', textColor)"
      stroke-width="3"
    />
    <path
      d="M66.9548 118.199C96.0939 125.75 107.435 136.029 123.87 158.988"
      :stroke="getColor('0.8', textColor)"
      stroke-width="3"
    />
    <path
      d="M149.308 143.538C143.358 127.212 143.532 119.482 147.573 107.079"
      :stroke="getColor('0.8', textColor)"
      stroke-width="3"
    />
    <path
      d="M119.931 172.373L131.172 169.416L128.115 180.622L119.931 172.373Z"
      :fill="getColor('1', primaryLight)"
    />
    <path
      d="M59.3436 70.7337L76.4682 66.2289L71.8104 83.299L59.3436 70.7337Z"
      :fill="getColor('0.3', primaryColor)"
    />
    <path
      d="M125.107 77.7224L133.962 62.3998L142.816 77.7224L125.107 77.7224Z"
      :fill="getColor('0.6', primaryColor)"
    />
    <path
      d="M130.495 33.3733L126.48 18.4011L141.465 22.4129L130.495 33.3733Z"
      :fill="getColor('0.3', primaryColor)"
    />
    <path
      d="M157.353 199.723L166.211 195.165L165.732 205.109L157.353 199.723Z"
      fill="white"
    />
    <path
      d="M145.068 163.355L150.497 166.486L145.068 169.618L145.068 163.355Z"
      :fill="getColor('0.7', primaryColor)"
    />
    <path
      d="M140.511 184.154L146.779 184.154L143.645 189.578L140.511 184.154Z"
      :fill="getColor('0.7', primaryColor)"
    />
    <path
      d="M171.137 212.138L175.57 207.71L177.192 213.759L171.137 212.138Z"
      :fill="getColor('0.7', primaryColor)"
    />
    <path
      d="M155.41 153.101L164.437 150.726L161.982 159.725L155.41 153.101Z"
      fill="white"
    />
    <path
      d="M157.696 182.554L162.212 174.391L167.029 182.38L157.696 182.554Z"
      :fill="getColor('1', primaryLight)"
    />
  </svg>
</template>

<script lang="ts">
import Vue from "vue"

export default Vue.extend({
  name: "ConfettiBag",
  props: {
    width: { type: String, default: "265" },
  },
  data() {
    return {
      primaryColor: this.$vuetify.theme.themes.light.primary,
      primaryLight: this.$vuetify.theme.themes.light.primaryLight,
      textColor: this.$vuetify.theme.themes.light.textColor,
    }
  },
  methods: {
    getColor(alphaString = "1", color) {
      let r = parseInt(color.slice(1, 3), 16),
        g = parseInt(color.slice(3, 5), 16),
        b = parseInt(color.slice(5, 7), 16)

      return "rgba(" + r + ", " + g + ", " + b + ", " + alphaString + ")"
    },
  },
})
</script>
